<template>
  <div class="invoice-details">
    <custom-dialog
      width="1280px"
      :title="model.title"
      :visible="visible"
      v-on="$listeners"
      :append-to-body="true"
    >
      <div class="dialog-body">
        <div class="record-detail">
          <div class="item-title">{{ $t('invoice_details_dialog.fa_piao_xin_xi') }}</div>
          <!-- invoiceBillList[0].billType  -->
          <!-- <p class="bill-type" v-if="invoiceInfo.invoiceBillList && invoiceInfo.invoiceBillList[0].billType">{{ getDicValue('bill_type', invoiceInfo.invoiceBillList[0].billType) }}</p> -->
          <invoice-ticket
            :data="invoiceInfo"
            :type="invoiceInfo.isRedInvoice"
          ></invoice-ticket>
          <div class="item-title">{{ $t('invoice_details_dialog.shang_pin_ming_xi') }}</div>
          <invoice-billList :data="invoiceInfo.invoiceBillList" :isRedInvoice="isRedInvoice"></invoice-billList>
        </div>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="visible = false"
        >{{ $t('Common.com_close') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import invoiceTicket from './invoice_ticket.vue';
import invoiceBillList from './invoice_billList.vue';

export default {
  mixins: [dialogMixins],
  components: { invoiceTicket, invoiceBillList },
  data() {
    return {
      invoiceId: '',
      isRedInvoice: '',
      invoiceInfo: {},
      billId: '',
    };
  },
  mounted() {
    this.invoiceId = this.model.invoiceId;
    this.isRedInvoice = this.model.type;
    this.billId = this.model.billId;
    this.getInvoiceDetail();
  },
  methods: {
    // 发票详情
    getInvoiceDetail: function () {
      // isRedInvoice true是冲红
      // isRedInvoice false是蓝票
      if (this.invoiceId) {
        if (this.isRedInvoice) {
          this.$getJSON(`${apis.invoiceGoRedDetail}/${this.invoiceId}`).then((res) => {
            this.invoiceInfo = res.data || {};
          });
        } else {
          this.$getJSON(`${apis.invoiceDetail}/${this.invoiceId}`).then((res) => {
            this.invoiceInfo = res.data || {};
          });
        }
      } else {
        this.$getJSON(`${apis.portalBillInvoiceDetail}/${this.billId}`).then((res) => {
          this.invoiceInfo = res.data || {};
        });
      }

    },
  },
};
</script>

<style lang="scss">
.invoice-details {
  .record-detail {
    padding: 20px 0;
    .bill-type {
      text-align: center;
      font-size: 18px;
      padding-bottom: 8px;
      line-height: 25px;
      letter-spacing: 1px;
      color: #000000;
      font-weight: bold;
    }
  }
}
</style>
